module.exports = __webpack_public_path__ + "fonts/Gilroy-Light.0e8ff4c1.ttf";